import {useGetDrawerSystemQuery} from 'components/customer/Product/store/drawerRunnerApi';

export const useGetDrawerSystem = () => {
    return useGetDrawerSystemQuery();
};
